import React, { useEffect, useState } from "react";

type PriceBlockWithChartProps = {
    price: string;
    pair: string;
    isUp: boolean | null;
};

export const PriceBlockWithChart: React.FC<PriceBlockWithChartProps> = ({ price, pair, isUp }) => {
    const formatted = parseFloat(price).toFixed(2);

    // История цен (последние 60 значений ≈ 1 минута)
    const [history, setHistory] = useState<number[]>([]);

    // Когда приходит новая цена → добавляем в историю
    useEffect(() => {
        const num = parseFloat(price);
        if (!isFinite(num)) return;

        setHistory(prev => {
            const updated = [...prev, num];
            return updated.slice(-60); // храним максимум 60 точек
        });
    }, [price]);

    // Формируем SVG path
    const createSparklinePath = (data: number[]) => {
        if (data.length < 2) return "";

        const max = Math.max(...data);
        const min = Math.min(...data);

        const width = 100;
        const height = 40;

        return data
            .map((p, i) => {
                const x = (i / (data.length - 1)) * width;
                const y = height - ((p - min) / (max - min || 1)) * height;
                return `${i === 0 ? "M" : "L"} ${x},${y}`;
            })
            .join(" ");
    };

    const path = createSparklinePath(history);

    return (
        <div
            className={`flex flex-col gap-2 p-4 bg-gray-50 rounded-lg border transition relative
                ${isUp === true ? "animate-[flashGreen_0.4s]" : ""}
                ${isUp === false ? "animate-[flashRed_0.4s]" : ""}
            `}
        >
            <div className="flex justify-between items-center">
                <div className="text-gray-700 font-medium">{pair}</div>

                <div className="flex items-center gap-2">
                    {isUp !== null && (
                        <span
                            className={`text-sm font-bold ${isUp ? "text-green-600" : "text-red-600"
                                }`}
                        >
                            {isUp ? "▲" : "▼"}
                        </span>
                    )}

                    <span
                        className={`text-lg font-bold ${isUp === true
                            ? "text-green-600"
                            : isUp === false
                                ? "text-red-600"
                                : "text-gray-900"
                            }`}
                    >
                        {formatted}
                    </span>
                </div>
            </div>

            {/* Мини-график */}
            <svg width="100%" height="40">
                <path
                    d={path}
                    stroke={isUp ? "#16a34a" : "#2563eb"}
                    strokeWidth="2"
                    fill="none"
                />
            </svg>
        </div>
    );
};